

export const typesConfiguration = {
    ingresarDatos : '[auth] Login',
    eliminarDatos: '[auth] Logout',
}